var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        { class: _vm.slideInClass },
        [
          _c("header", [
            _c("div", { staticClass: "close-container" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close(false)
                    }
                  }
                },
                [_c("Icon", { attrs: { icon: "close" } })],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "scrollbar-check" },
            [
              _c("Edit", {
                attrs: { meta: _vm.meta },
                model: {
                  value: _vm.career,
                  callback: function($$v) {
                    _vm.career = $$v
                  },
                  expression: "career"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "footer",
            [
              _c("Button", {
                attrs: {
                  text: _vm.career ? "Eintrag speichern" : "Eintrag hinzufügen",
                  disabled: !_vm.career,
                  icon: "checkmark"
                },
                on: { click: _vm.careerSaved }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showErrors
            ? _c(
                "PopUp",
                {
                  attrs: {
                    title: "Fehlende Daten",
                    "ok-text": "OK",
                    "hide-cancel": ""
                  },
                  on: {
                    ok: function($event) {
                      _vm.showErrors = false
                    },
                    hidden: function($event) {
                      _vm.showErrors = false
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mb-3 color-primary font-weight-extra-bold"
                    },
                    [_vm._v("Bitte überprüfe die folgenden Felder:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "content-list" },
                    _vm._l(_vm.career.errors, function(error, i) {
                      return _c("li", { key: "error-" + i }, [
                        _vm._v(_vm._s(error))
                      ])
                    }),
                    0
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }